import { colors, fonts } from '@grupoboticario/flora-tokens/dist/truss/web/ds'

export const truss = {
  colors,
  fonts,
}
